import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PumpAdvisor from "./pages/PumpAdvisor";
import LeadsAdmin from "./pages/LeadsAdmin";
import CatalogAdmin from "./pages/CatalogAdmin";

function App() {
  return (
    <div className="min-h-screen bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PumpAdvisor />} />
          <Route path="/admin/leads" element={<LeadsAdmin />} />
          <Route path="/admin/catalog" element={<CatalogAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
